module.exports = __webpack_public_path__ + "img/084.6c59f068.png";